import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./assets/i18n/de.json";
import en from "./assets/i18n/en.json";
import { i18nextPlugin } from "translation-check";
import {
  DEFAULT_APP_LANGUAGE,
  getInitialAppLanguage,
  normalizeAppLanguage,
  SUPPORTED_APP_LANGUAGES,
  syncDocumentLanguage,
} from "./lib/app-language";

const resources = {
  en: {
    translation: {
      ...en,
    },
  },
  de: {
    translation: {
      ...de,
    },
  },
};

const initialLanguage = getInitialAppLanguage();
syncDocumentLanguage(initialLanguage);

const i18nInstance = i18n.use(initReactI18next);
if (import.meta.env.DEV && i18nextPlugin) {
  i18nInstance.use(i18nextPlugin);
}
i18nInstance.init({
  resources,
  lng: initialLanguage,
  fallbackLng: DEFAULT_APP_LANGUAGE,
  supportedLngs: [...SUPPORTED_APP_LANGUAGES],
  nonExplicitSupportedLngs: true,
  load: "languageOnly",
  interpolation: {
    escapeValue: false,
  },
});

i18nInstance.on("languageChanged", (lng) => {
  const normalized = normalizeAppLanguage(lng);
  syncDocumentLanguage(normalized);
  try {
    localStorage.setItem("i18nextLng", normalized);
  } catch (error) {
    console.warn("Failed to save language to localStorage:", error);
  }
});

export default i18n;
